import { render, staticRenderFns } from "./sticky-top.vue?vue&type=template&id=93571d46&scoped=true&"
var script = {}
import style0 from "./sticky-top.vue?vue&type=style&index=0&id=93571d46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93571d46",
  null
  
)

export default component.exports